import { render } from "./Baumkataster.vue?vue&type=template&id=22e3716a&scoped=true&ts=true"
import script from "./Baumkataster.vue?vue&type=script&lang=ts"
export * from "./Baumkataster.vue?vue&type=script&lang=ts"

import "./Baumkataster.vue?vue&type=style&index=0&id=22e3716a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e3716a"]])

export default __exports__